var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"sidebar"}},[_c('Menu',{attrs:{"id":"sb-main-menu","k":"main-menu","toggle-event":"click"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }